import { Route, Routes as RouterRoutes } from "react-router-dom";
import About from "./views/About/About";
import Calendar from "./views/Calendar/Calendar";
import Contact from "./views/Contact/Contact";
import FestDetail from "./views/FestDetail/FestDetail";
import Fests from "./views/Fests/Fests";
import MapView from "./views/Map/MapView";

export const routeList = [
  {
    path: "/",
    element: <MapView />,
    title: "Forteana | Ghost hunts, cryptids, overnight strangeness.",
  },
  {
    path: "/fests",
    element: <Fests />,
    title: "Places | Forteana",
  },
  {
    path: "/fests/:id",
    element: <FestDetail />,
    title: "Fest | Forteana",
  },
  {
    path: "/calendar",
    element: <Calendar />,
    title: "Calendar | Forteana",
  },
  {
    path: "/about",
    element: <About />,
    title: "About | Forteana",
  },
  {
    path: "/contact",
    element: <Contact />,
    title: "Contact | Forteana",
  },
];

export const AppRoutes = () => (
  <RouterRoutes>
    {routeList.map((route) => (
      <Route key={route.path} path={route.path} element={route.element} />
    ))}
  </RouterRoutes>
);
